import { useEffect } from "react"
import { useDispatch } from "react-redux"
import styled from "styled-components"
import { adminGetUyeAraclarByUserId } from "../../features/admin2/admin2Slice"
import { useSelector } from "react-redux"

const Container = styled.div`
    width: 100%;
    color: ${({theme}) => theme.mainTextColor};
    display: flex;
    flex-direction: column !important;

    .titles-container{
        width: 100%;
        display: flex;
        text-align: center;
        margin-bottom: 20px;

        .title-item{
            flex: 1;
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-lg);
        }
    }

    .arac-list-container{
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .arac-item{
            display: flex;
            align-items: center;

            .arac-item-data{
                flex: 1;
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-lg);
                text-align: center;
            }
        }
    }

`
const titles = [
    "Plaka",
    "Araç Türü",
    "Araç Tipi",
    "Kasa Tipi",
    "YB",
    "Belgeler",
    "İşlemler"
]

const KooperatifUyeAraclar = () => {

    const dispatch = useDispatch()
    const {uyeItemData, singleUyeAracList} = useSelector(state => state.uyelerAraclar)

    useEffect(() => {
        dispatch(adminGetUyeAraclarByUserId(uyeItemData.id))
    },[])
  return (
    <Container>
        <div className="titles-container">
            {
                titles.map((item) => (
                    <div className="title-item">{item}</div>
                ))
            }
            </div>
            <div className="arac-list-container">
                {
                    singleUyeAracList?.map(item => (
                        <div className="arac-item">
                            <div className="arac-item-data">{item.truckPlateNumber}</div>
                            <div className="arac-item-data">{item.truckSubType}</div>
                            <div className="arac-item-data">{item.truckType}</div>
                            <div className="arac-item-data">{item.trailerType}</div>
                            <div className="arac-item-data">{item.plaka}</div>
                            <div className="arac-item-data">{item.plaka}</div>
                            <div className="arac-item-data">{item.plaka}</div>
                        </div>
                    ))
                }
            </div>
    </Container>
  )
}

export default KooperatifUyeAraclar